import styled from 'styled-components';

export const Cart = styled.div`
  cursor: pointer;
  width: 48px;
  height: 48px;
  position: relative;
  padding: 10px;

  svg {
    fill: #fff;
  }
`;

export const CartCount = styled.span`
  border-radius: 50%;
  font-size: 0.786em;
  font-weight: 900;
  line-height: 1;
  min-width: 1.75em;
  padding: 0.4em;
  position: absolute;
  left: 50%;
  text-align: center;
  top: 12%;
  background-color: ${({ theme }) => theme.color.brandSecondary};
  color: ${({ theme }) => theme.color.brandPrimary};
`;
